/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAttribute = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 2v20H2V2zm-2 2H4v16h16zM6.042 9.184l1.336 2.208 1.336-2.208h.996l.045.077-1.697 2.763L9.89 15H8.762L7.33 12.624 5.914 15H4.826l1.832-3-1.744-2.816zm4.796 0 1.464 2.648 1.456-2.648h1.088l-2.064 3.544V15h-1v-2.272L9.755 9.261l.047-.077zm8.332 0v.696l-2.992 4.272h3.072V15h-4.328v-.712l2.984-4.256h-2.888v-.848z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgAttribute as Attribute };
